import { z } from 'zod';

import { BillingConfig, BillingProviderSchema, createBillingSchema } from '@kit/billing';
import { billingConfig as productionConfig, getBenefitByLineId as getProdBenefitByLineId } from './billing.production.config';
import { billingConfig as xenditProductionConfig, getBenefitByLineId as getXenditProdBenefitByLineId} from './billing-xendit.production.config';
import { billingConfig as lemonsqueezySandboxConfig, getBenefitByLineId as getLemonSqueezySandboxBenefitByLineId } from './billing-lemonsqueezy.sandbox.config';
import { billingConfig as lemonsqueezyProductionConfig, getBenefitByLineId as getLemonSqueezyProductionBenefitByLineId } from './billing-lemonsqueezy.production.config';
import { billingConfig as sandboxConfig, getBenefitByLineId as getSandboxBenefitByLineId } from './billing.sandbox.config';
import appConfig from './app.config';

const provider = BillingProviderSchema.parse(
  process.env.NEXT_PUBLIC_BILLING_PROVIDER,
);

export const checkProviderIsActive = (billingProvider: z.infer<typeof BillingProviderSchema>) => {
  return provider === billingProvider;
}

export const getConfigByProviderAndEnv = (params?: { 
  provider?: z.infer<typeof BillingProviderSchema>; 
  isProduction?: boolean 
}): BillingConfig => {
  // Use provided values or fall back to defaults
  const selectedProvider = params?.provider ?? provider;
  const isProduction = params?.isProduction ?? appConfig.production;
  
  if (isProduction) {
    switch (selectedProvider) {
      case 'xendit':
        return xenditProductionConfig;
      case 'lemon-squeezy':
        return lemonsqueezyProductionConfig;
      case 'stripe':
        return productionConfig;
      default: 
        return lemonsqueezyProductionConfig;
    }
  } else {
    switch (selectedProvider) {
      case 'xendit':
        return xenditProductionConfig;
      case 'lemon-squeezy':
        return lemonsqueezySandboxConfig;
      case 'stripe':
        return sandboxConfig;
      default: 
        return lemonsqueezySandboxConfig;
    }
  }
}

const getBenefitLineIdByProviderAndEnv = () => {
  if (appConfig.production) {
    switch (provider) {
      case 'xendit':
        return getXenditProdBenefitByLineId;
      case 'lemon-squeezy':
        return getLemonSqueezyProductionBenefitByLineId;
      case 'stripe':
        return getProdBenefitByLineId;
      default: 
        return getLemonSqueezyProductionBenefitByLineId;
    }
  } else {
    switch (provider) {
      case 'xendit':
        return getXenditProdBenefitByLineId;
      case 'lemon-squeezy':
        return getLemonSqueezySandboxBenefitByLineId;
      case 'stripe':
        return getSandboxBenefitByLineId;
      default: 
        return getLemonSqueezySandboxBenefitByLineId;
    }
  }
}

export const getBenefitByLineId = getBenefitLineIdByProviderAndEnv();

export default createBillingSchema(getConfigByProviderAndEnv());